import { Visibility, VisibilityOff } from '@mui/icons-material'
import { type MouseEventHandler } from 'react'

import { Tooltip } from '../../../../../components/primitives/Tooltip'
import { ListItemIcon } from '../ListItemIcon'
import { useTexts } from './hooks/useTexts'

export type Props = {
  visible: boolean
  toggleVisibility: MouseEventHandler<HTMLElement>
  disabled?: boolean
  disabledTooltip?: string
}

export function ListItemVisibilityToggler(props: Props) {
  const { visible, toggleVisibility, disabled = false, disabledTooltip } = props
  const texts = useTexts()

  const tooltipTitle =
    disabled && disabledTooltip ? disabledTooltip : texts.visibilityTooltip(visible)

  return (
    <Tooltip placement="bottom" title={tooltipTitle}>
      <ListItemIcon
        icon={visible ? <Visibility /> : <VisibilityOff />}
        onClick={toggleVisibility}
        disabled={disabled}
      />
    </Tooltip>
  )
}
